import { faCalendar, faCircleCheck, faPhone, faTag, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { OrderStatuses } from 'service';
import { OrderHeader } from './OrderHeader';

type OrderDisplayProps = {
    order: any;
    user: any;
    onSetActiveTab: (tab: string) => void;
};

export const OrderDisplay = ({ order, user, onSetActiveTab }: OrderDisplayProps) => {
    const getDisplayImage = (item) => {
        if (item.customImageUrl && item.customImageUrl.length > 0) {
            return item.customImageUrl;
        }
        if (item.style?.imageUrl) {
            return item.style.imageUrl;
        }
        if (item.productMaster?.imageUrl) {
            return item.productMaster.imageUrl;
        }
        // Return null if no image
        return null;
    };

    return (
        <div key={order.id} className="card mb-2">
            <div className="card-header">
                <h3 className="order-id">Order ID: <b>{order.voucherNumber}</b></h3>
            </div>
            {order?.id > 0 && (
                <>
                    <OrderHeader order={order} user={user} />
                    <div className="card-body p-0">
                        {order.items.map((item, index) => (
                            <div key={index}>
                                <div className="card-header item-header">
                                    <b>{item.product.name}</b>
                                    {item.style?.name && (
                                        <div className="item-style">Style: {item.style.name}</div>
                                    )}
                                    {item.notes && (
                                        <div className="item-narration">Note: <span className="text-danger fw-bold">{item.notes}</span></div>
                                    )}
                                </div>
                                <div className="row align-items-start g-2">
                                    {/* Left: Product Image */}
                                    <div className="col-6">
                                        <div className="card h-100">
                                            <div className="card-img-top text-center">
                                                {getDisplayImage(item)
                                                    ? <img src={getDisplayImage(item)} alt="product" style={{ maxHeight: '200px' }} />
                                                    : <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '200px', color: '#ccc' }}>
                                                        <span>No Image</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right: Status Cards (Stacked Vertically) */}
                                    <div className="col-6">
                                        <div className="d-flex flex-column gap-0">
                                            {/* Confirmed Card */}
                                            <div className="card text-center p-1">
                                                <span className="stage-name">Confirmed</span>
                                                <div className="d-inline-flex justify-content-center align-items-center fw-bold">
                                                    {(order.status > 1)
                                                        ? <>
                                                            <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1" />
                                                            {item.quantity}
                                                        </>
                                                        : <span className="text-muted">--</span>
                                                    }
                                                </div>
                                            </div>

                                            {/* Pressed Card */}
                                            <div className="card text-center p-1">
                                                <span className="stage-name">Pressed</span>
                                                <div className="d-inline-flex justify-content-center align-items-center fw-bold">
                                                    {(item.pressedQuantity && item.quantity <= item.pressedQuantity)
                                                        ? <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1" />
                                                        : null
                                                    }
                                                    {item.pressedQuantity || <span className="text-muted">0</span>}
                                                </div>
                                            </div>

                                            {/* Packed Card */}
                                            <div className="card text-center p-1">
                                                <span className="stage-name">Packed</span>
                                                <div className="d-inline-flex justify-content-center align-items-center fw-bold">
                                                    {(item.packedQuantity && item.quantity <= item.packedQuantity)
                                                        ? <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1" />
                                                        : null
                                                    }
                                                    {item.packedQuantity || <span className="text-muted">0</span>}
                                                </div>
                                            </div>

                                            {/* Dispatched Card */}
                                            <div className="card text-center p-1">
                                                <span className="stage-name">Dispatched</span>
                                                <div className="d-inline-flex justify-content-center align-items-center fw-bold">
                                                    {(item.pendingQuantity === 0)
                                                        ? <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1" />
                                                        : null
                                                    }
                                                    {(item.quantity - item.pendingQuantity) || <span className="text-muted">0</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*{getDisplayImage(item) && (
                                    <div className="card-img-top text-center">
                                        <img src={getDisplayImage(item)} alt="product" style={{ maxHeight: '250px' }} />
                                    </div>
                                )}
                                {order.status > 1 && order.status < 6 && (
                                    <>
                                        <div className="card-body p-0">
                                            <div key={index + "-qty"} className="row m-0 p-1 item-quantities">
                                                {(order.status > 1) && (
                                                    <div className="text-center col-3 card p-1">
                                                        <span className="stage-name">Confirmed</span>
                                                        <span className="d-inline-flex align-items-center justify-content-center fw-bold">
                                                            <>
                                                                <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1 float-start" />
                                                                {item.quantity}
                                                            </>
                                                        </span>
                                                    </div>
                                                )}
                                                {(order.status == 1) && (
                                                    <div className="text-center col-3 card p-1">
                                                        <span className="stage-name">Ordered</span>
                                                        <span className="d-inline-flex align-items-center justify-content-center fw-bold">
                                                            {item.quantity}
                                                        </span>
                                                    </div>
                                                )}
                                                <div className="text-center col-3 card p-1">
                                                    <span className="stage-name">Pressed</span>
                                                    <span className="d-inline-flex align-items-center justify-content-center fw-bold">
                                                        {(item.quantity <= item.pressedQuantity) && (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1 float-start" />
                                                        )}
                                                        {item.pressedQuantity || 0}
                                                    </span>
                                                </div>
                                                <div className="text-center col-3 card p-1">
                                                    <span className="stage-name">Packed</span>
                                                    <span className="d-inline-flex align-items-center justify-content-center fw-bold">
                                                        {(item.quantity <= item.packedQuantity) && (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1 float-start" />
                                                        )}
                                                        {item.packedQuantity || 0}
                                                    </span>
                                                </div>
                                                <div className="text-center col-3 card p-1">
                                                    <span className="stage-name">Dispatched</span>
                                                    <span className="d-inline-flex align-items-center justify-content-center fw-bold">
                                                        {(item.pendingQuantity == 0) && (
                                                            <FontAwesomeIcon icon={faCircleCheck} className="text-success me-1 float-start" />
                                                        )}
                                                        {(item.quantity - item.pendingQuantity) || 0}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}*/}
                            </div>
                        ))}
                    </div>
                    {(user && user.roleId <= 4) && (order.status === 2 || order.status === 3) &&
                        // Only users with roleId less than 4 (Not for ORDER HANDLER) can add production or edit quantity
                        <>
                            <div className="card-footer">
                                <div className="btn btn-sm btn-dark w-100 mb-2" onClick={() => onSetActiveTab("addProduction")}>
                                    <span>Add Production</span>
                                </div>
                                <div className="btn btn-sm btn-dark w-100" onClick={() => onSetActiveTab("updateQuantity")}>
                                    <span>Update Quantity</span>
                                </div>
                            </div>
                        </>
                    }
                    {(user && user.roleId <= 3) && (order.status === 1) &&
                        // Only users with roleId less than 3 (Not for ORDER MANAGER) can edit orders
                        <div className="card-footer">
                            <div className="btn btn-sm btn-dark w-100" onClick={() => onSetActiveTab("confirmOrder")}>
                                <span>Confirm Order</span>
                            </div>
                        </div>
                    }
                </>
            )}
        </div>
    );
}